/* eslint-disable no-new */
import { Scheme } from './scheme';

const build = () => {
  new Scheme();
};

export default build;
